import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import SegmentMessage from "./SegmentMessage.jsx";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class ValidationMessage extends PureComponent {
  static propTypes = {
    dismissable: PropTypes.bool.isRequired,
    timed: PropTypes.bool.isRequired,
    valid: PropTypes.bool.isRequired,
    copyKey: PropTypes.string,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    dismissable: false,
    timed: false,
    valid: false,
    copyKey: "forms.validation_message"
  };

  // -- RENDER -- //

  render() {
    const { dismissable, timed, valid, className, style, copyKey, copy } =
      this.props;

    const positive = valid;
    const negative = !valid;

    const messageCopyKey = valid ? `${copyKey}.valid` : `${copyKey}.invalid`;

    return (
      <SegmentMessage
        title={copy(`${messageCopyKey}.title`)}
        message={copy(`${messageCopyKey}.message`)}
        timed={timed}
        dismissable={dismissable}
        negative={negative}
        positive={positive}
        className={className}
        style={style}
      />
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ValidationMessage);
